import { jsx as _jsx } from "react/jsx-runtime";
import { Form, useForm } from "../components/Form";
export const RenderWithReactHookForm = ({ values = {}, children, mode }) => {
    const form = useForm({ defaultValues: values, mode });
    const noop = () => undefined;
    return (_jsx(Form, { form: form, onSubmit: noop, children: children }));
};
//# sourceMappingURL=jestHelpers.js.map